//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {HotelSearchProxy} from '@/http/RequestProxy.class.js';
import {StarLevel} from '@/components';

const hotelSearch = new HotelSearchProxy();

export default {
  name: 'nearby-hotel',
  components: {StarLevel},
  props: {
    baseParams: Object,
    latitude: String | Number,
    longitude: String | Number,
    originHotel: String | Number,   // 原酒店ID
  },
  data(){
    return {
      nearbyHotels: [],
      routeDate: '',
    };
  },
  watch: {
    latitude(){
      this.routeDate = `${this.baseParams.start_date}/${this.baseParams.end_date}`;
      this.getNearbyHotel();
    },
  },
  methods: {
    getNearbyHotel(){
      const params = {
        date_from: this.baseParams.start_date,
        date_to: this.baseParams.end_date,
        adults: this.baseParams.adults,
        children: this.baseParams.children,
        room_count: this.baseParams.room_count,
        location: `${this.latitude},${this.longitude},5000`,
        sort_by: 4,
        page: 1,
        region_id: '',
        hotel_id: '',
        place_id: '',
        room_category: '',
        options: '',
        filter_options: '',
        without_hotel: this.originHotel,
      };

      hotelSearch.getHotelList(params)
        .then(resp => {
          if(resp){
            this.nearbyHotels = resp.data.hotel.splice(0, 6);
          }
        });
    },

    onRoute2Detail(hotelId){
      const link = `/hotel/detail/${hotelId}/${this.routeDate}`;

      this.$router.replace({name: 'middle-page', query: {path: link}});
      // this.$router.replace(link);
      // window.location.reload();
    },
  },
}



// WEBPACK FOOTER //
// ./src/views/hotel-detail/components/NearbyHotel.vue